import React, { useState } from "react";
import "./Filter.css";

export default function Filter(props) {
  const nse = props.nse;
  const nse_cash = props.nse_cash;
  const mcx = props.mcx;
  const options = props.options;

  const [searchsymbol, setSearchSymbol] = useState("");

  return (
    <div className="filter">
      <div className="filterleft">
        {nse == 1 ? (
          <button
            onClick={() => props.filter("0")}
            className={"dropbtnNavSub primary marginright white"}
          >
            NSE
          </button>
        ) : null}
      </div>
      <div className="filterright">
        <button
          onClick={() => {
            props.close();
          }}
          className={"dropbtnNavSub textwhite sell marginright marginleft"}
        >
          Close
        </button>
      </div>
    </div>
  );
}
